<template>
  <AppLayout>
    <div class="task-page">
      <div class="grid">
        <el-card v-for="item in list" :key="item.id" class="task-card" shadow="never" body-style="padding: 0">
          <div class="card-inner" @click="jop(item)">
            <h3 class="title">{{ item.title }}</h3>

            <div class="badge-row">
              <el-tag class="badge" type="success" effect="plain">需用</el-tag>
            </div>

            <div class="meta-row">
              <div class="meta-item">
                <img class="meta-icon" src="../assets/项目预算 1@2x.png" alt="" />
                <div class="meta-text">
                  <div class="meta-main">¥ {{ item.budget }}</div>
                  <div class="meta-sub">项目预算</div>
                </div>
              </div>

              <div class="meta-item">
                <img class="meta-icon" src="../assets/截止时间 1@2x.png" alt="" />
                <div class="meta-text">
                  <div class="meta-main">{{ item.deadline }}</div>
                  <div class="meta-sub">截止时间</div>
                </div>
              </div>

              <div class="meta-item">
                <img class="meta-icon" src="../assets/定位 1@2x.png" alt="" />
                <div class="meta-text">
                  <div class="meta-main">{{ item.mode }}</div>
                  <div class="meta-sub" style="margin-top: 4px;">位置</div>
                </div>
              </div>
            </div>

            <p class="desc">{{ item.desc }}</p>

            <div class="tags">
              <el-tag v-for="t in item.tags" :key="t" class="pill" type="info" effect="plain">
                {{ t }}
              </el-tag>
            </div>

            <div class="bottom">
              <el-button class="cta" type="success" @click.stop="openQuote(item)">
                立即报价
                <img class="arrow" src="../assets/next.png" alt="" />
              </el-button>
              <div class="bottom-meta"></div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 报价弹窗 -->
      <el-dialog v-model="quoteOpen" width="640px" align-center :teleported="false" :show-close="false"
        :close-on-click-modal="true" :close-on-press-escape="true" class="quote-dialog">
        <div class="quote-body">
          <div class="quote-title">立即报价</div>

          <el-form ref="quoteFormRef" class="quote-form" :model="quoteForm" :rules="quoteRules" label-position="top"
            status-icon :hide-required-asterisk="false" @submit.prevent>
            <el-form-item label="金额" prop="price" required>
              <el-input v-model.trim="quoteForm.price" placeholder="请输入" />
            </el-form-item>

            <el-form-item label="预计完成时间" prop="eta" required>
              <el-date-picker v-model="quoteForm.eta" type="date" placeholder="请选择" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" style="width: 100%" />
            </el-form-item>

            <el-button class="quote-submit" type="success" :loading="submitting" @click="submitQuote">
              提交
            </el-button>
          </el-form>
        </div>
      </el-dialog>

      <!-- 报价成功弹窗 -->
      <el-dialog v-model="successOpen" width="420px" align-center :teleported="false" modal :lock-scroll="true"
        :show-close="false" :close-on-click-modal="true" :close-on-press-escape="true" class="success-dialog">
        <div class="success-body">
          <img class="success-icon" src="../assets/Frame 9800.png" alt="" />
          <div class="success-title">报价成功</div>
          <div class="success-desc">报价成功，等待甲方回复</div>

          <div class="success-actions">
            <el-button type="success" class="success-cta" @click="continueBrowse">继续浏览</el-button>
            <el-button type="success" link @click="goHome">返回首页</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </AppLayout>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const router = useRouter()

const list = ref(
  Array.from({ length: 8 }).map((_, i) => ({
    id: i + 1,
    title: '项目名称项目名称项目名称项目名称项目名称项目名称项目名称',
    budget: 1000,
    deadline: '2026-01-01',
    mode: '线上',
    desc:
      '项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍…',
    tags: ['技能1', '技能2', '技能2', '技能2'],
  }))
)

/* ===== 报价弹窗逻辑 ===== */
const quoteOpen = ref(false)
const successOpen = ref(false)
const submitting = ref(false)
const currentTask = ref(null)

const quoteFormRef = ref(null)
const quoteForm = reactive({
  price: '',
  eta: '', // YYYY-MM-DD
})

function validateMoney(_rule, v, cb) {
  const val = String(v ?? '').trim()
  if (!val) return cb(new Error('请输入金额'))
  if (!/^\d+(\.\d{1,2})?$/.test(val)) return cb(new Error('金额格式不正确（最多两位小数）'))
  const n = Number(val)
  if (!Number.isFinite(n) || n <= 0) return cb(new Error('金额必须大于 0'))
  cb()
}

function validateEta(_rule, v, cb) {
  const val = String(v ?? '').trim()
  if (!val) return cb(new Error('请选择预计完成时间'))
  cb()
}

const quoteRules = reactive({
  price: [
    { required: true, message: '请输入金额', trigger: 'blur' },
    { validator: validateMoney, trigger: ['blur', 'change'] },
  ],
  eta: [
    { required: true, message: '请选择预计完成时间', trigger: 'change' },
    { validator: validateEta, trigger: 'change' },
  ],
})

function openQuote(task) {
  console.log(1111111)
  currentTask.value = task
  quoteForm.price = ''
  quoteForm.eta = ''
  quoteOpen.value = true
}
function jop() {

  router.push('/tasksDetail')
}
async function submitQuote() {
  if (!quoteFormRef.value) return
  try {
    await quoteFormRef.value.validate()
    submitting.value = true
    await new Promise((r) => setTimeout(r, 600))
    quoteOpen.value = false
    successOpen.value = true
  } catch {
    // 校验不通过：自动显示错误提示
  } finally {
    submitting.value = false
  }
}

function continueBrowse() {
  successOpen.value = false
}

function goHome() {
  successOpen.value = false
  router.push('/home')
}
</script>

<style lang="scss" scoped>
.task-page {
  min-height: calc(100vh - 64px);
  padding: 28px 240px 64px;
  background-image: url('../assets/未标题-1 1.png');

  @media (max-width: 1400px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  @media (max-width: 960px) {
    padding: 18px 16px 48px;
  }
}

.grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
}

.task-card {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.1), -4px -4px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid #e9e9e9;
  overflow: hidden;

  :deep(.el-card__body) {
    padding: 0 !important;
  }
}

.card-inner {
  padding: 28px;
  cursor: pointer;
}

:deep .el-date-editor.el-input,
.el-date-editor.el-input__wrapper {
  height: 48px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #D1D5DB;
}

.title {
  margin: 0 0 18px;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
  line-height: 1.45;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.badge-row {
  margin-bottom: 25px;

  :deep(.badge.el-tag) {
    width: 55px;
    height: 24px;
    border-radius: 8px;
    border: 1px solid #4caf50;
  }
}

.meta-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 33px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

.meta-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.meta-icon {
  width: 24px;
  height: 24px;
}

.meta-text {
  padding-top: 2.5px;
}

.meta-main {
  font-size: 16px;
  color: #000000;
}

.meta-sub {
  margin-top: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #a5a5a5;
}

.desc {
  margin: 0 0 25px;
  font-weight: 400;
  font-size: 14px;
  color: #181818;
  line-height: 25px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 28px;

  :deep(.pill.el-tag) {
    width: 96px;
    height: 32px;
    background: #f6f6f6;
    border: none;
    border-radius: 20px;
    font-weight: 400;
    font-size: 12px;
    color: #676767;
    line-height: 12px;
  }
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

}

:deep(.cta.el-button) {
  width: 101px;
  height: 36px;
  background: #4caf50;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 14px;


  .arrow {
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }
}

/* ===== 报价弹窗样式（修复校验遮挡） ===== */
:deep(.quote-dialog .el-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.quote-dialog .el-dialog__header) {
  display: none;
}

:deep(.quote-dialog .el-dialog__body) {
  padding: 0;
}

.quote-body {
  padding: 32px 63px;
}

.quote-title {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  margin: 0px 0 18px;
}

/* ✅ 强力版：只作用在当前弹窗的表单，确保错误提示不覆盖 */
:deep(.quote-dialog .quote-form) {
  .el-form-item {
    margin-bottom: 18px;
  }

  .el-form-item__label {
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    padding-bottom: 6px;
  }

  .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: static !important;
  }

  .el-form-item__error,
  .el-form-item__error--inline {
    position: static !important;
    display: block !important;
    width: 100%;

    margin-top: 6px;
    padding: 0;
    line-height: 1.2;
    white-space: normal;

    z-index: auto !important;
    transform: none !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
  }

  .el-input__wrapper,
  .el-date-editor .el-input__wrapper {
    min-height: 48px;
    border-radius: 6px;
    box-sizing: border-box;
  }
}

:deep(.quote-submit.el-button) {

  height: 48px;
  background: #4CAF50;
  border-radius: 4px 4px 4px 4px;
  width: 100%;

  margin-top: 36px;

  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

/* 成功弹窗样式（保持不动） */
:deep(.success-dialog .el-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.success-dialog .el-dialog__header) {
  display: none;
}

:deep(.success-dialog .el-dialog__body) {
  padding: 32px 63px;
}

.success-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.success-icon {
  margin: 0px 0 28px;
  width: 100px;
  height: 100px;

  .ring {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: linear-gradient(180deg, #6fe36a 0%, #34b34a 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 22px rgba(46, 160, 67, 0.25);
  }

  .check {
    color: #fff;
    font-size: 44px;
    font-weight: 800;
    line-height: 1;
  }
}

.success-title {
  font-weight: 400;
  font-size: 20px;
  color: #2E323E;
  margin-bottom: 6px;
}

.success-desc {
  font-weight: 400;
  font-size: 16px;
  color: #9899A2;
  margin-bottom: 48px;
}

.success-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
}

:deep(.success-cta.el-button) {
  width: 260px;
  height: 41px;
  background: linear-gradient(39deg, #4CAF50 0%, #91DF35 100%);
  box-shadow: 2px 2px 4px 0px rgba(24, 144, 255, 0.1);
  border-radius: 200px 200px 200px 200px;
  // margin-bottom: 6px;
}
</style>